import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateBranchForm from '../../forms/CreateOrUpdateBranchForm'

interface CreateBranchModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateBranchModal: React.FC<CreateBranchModalProps> = ({ open, onClose, loading, error }) => (
  <AppModal open={open} onClose={onClose} title="Add New Branch" width="md" loading={loading}>
    <CreateOrUpdateBranchForm loading={loading} error={error} />
  </AppModal>
)

export default CreateBranchModal
